import { useEffect } from 'react';
import { EventActionInterface, EventManagerHookInterface } from './types';

const useEventManager: EventManagerHookInterface = (props) => {
  useEffect(() => {
    props.forEach(({ event, action }: EventActionInterface) => {
      document.addEventListener(event, action);
    });
    return () => {
      props.forEach(({ event, action }: EventActionInterface) => {
        document.removeEventListener(event, action);
      });
    };
  }, []);
};

export default useEventManager;
